import CrudRequest from '@rootCommon/services/crud-request';
import { PERMISSIONS } from '@rootCommon/constants/end-points';
import { Permission, PermissionTemplateCode } from '@rootCommon/types/permission';
import { ADMIN } from '@rootCommon/constants/common';

const PERMISSIONS_ADMIN = `${PERMISSIONS}/${ADMIN}`;

class PermissionsService extends CrudRequest<Permission, Permission> {
  constructor() {
    super(PERMISSIONS_ADMIN);
  }

  getListByCode = async (code: PermissionTemplateCode): Promise<Permission[]> => {
    const res = await CrudRequest.get<Permission[]>(PERMISSIONS_ADMIN, {
      params: { code },
    });

    return res.data;
  };
}

export default new PermissionsService();
